module.exports = __webpack_public_path__ + "static/img/iphone_3.ec47199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_3.png
// module id = qAZp
// module chunks = 0